module.exports = __webpack_public_path__ + "img/cockpit-dialog_bg.c7d328bf.png";